<tec-base>
  @if (showTestModeBanner) {
    <tec-alert
      type="message"
      status="warning"
      [msg]="'COMMON.TEST_MODE_BANNER' | translate"
      icon="icon-rocket"
      [hiddenCloseButton]="true"
    ></tec-alert>
  }
  <tec-topnav
  #mainTopnav
  [menu]="topnavMenu()" img="/assets/images/img_tecalis_logo.svg"
  [title]="'Billing'"
  >
    <tec-link [href]="billingLegacyUrl" [label]="'COMMON.BILLING_LEGACY' | translate" [size]="'sm'"></tec-link>

    <tec-menu trigger
      [options]="[
        {label: 'COMMON.PROFILE' | translate, icon: 'icon-users', id: 'profile'},
        {label: 'COMMON.LOGOUT' | translate, icon: 'icon-log-out', id: 'logout', divider: true, style: 'red'}
      ]"
      (valueChange)="onMenuOption($event)">
      <!-- Tooltip solo con size default y showName false; si la foto 404, Infinity fuerza showName. -->
      <tec-avatar
        #topnavAvatarEl
        [avatar]="topnavAvatar()"
        size="default"
      ></tec-avatar>
    </tec-menu>

  </tec-topnav>
  @if(!tabletSize()) {
    <tec-sidenav #mainSidenav [confSidenav]="sidenavConfig()" [usePanel]="true"></tec-sidenav>
  }
  <router-outlet (activate)="onOutletActivate($event)" />
</tec-base>

@if (contratoCrearNav.modalVisible()) {
  <app-contrato-tipo-modal
    [isVisible]="true"
    (confirmado)="contratoCrearNav.confirm($event)"
    (cancelado)="contratoCrearNav.cancel()"
  ></app-contrato-tipo-modal>
}
